export const BATCH_ACTIONS = 'BATCH_ACTIONS';
export const RESIZE = 'RESIZE';
export const ROLL_HOME = 'ROLL_HOME';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const OUT_HOME = 'OUT_HOME';
export const CHANGE_FRAME_HOME = 'CHANGE_FRAME_HOME';
